import App from "./App";
import { AppContextProvider } from "./context/AppContext";

const AppWrapper = () => {
  return (
    <AppContextProvider>
      <App />
    </AppContextProvider>
  );
};

export default AppWrapper;
